import React from 'react';
import './LocationBadge.css';
import locationIcon from './../../../assets/icons/ui/location.svg';

interface LocationBadgeProps {
  location: string;
  link: string;
}

const LocationBadge: React.FC<LocationBadgeProps> = ({ location, link }) => {
  return (
    <a href={link} target="_blank" rel="noopener noreferrer" className="location-badge">
      <img src={locationIcon} alt="Location" className="location-icon" />
      {location}
    </a>
  );
};

export default LocationBadge;
